export const themes = {
    1: {
        id:1,
        name: "Light-Blue",
        darkTheme: false,
        colorTitle: "blue",
        borderRadius: 2,

        primary: "#0078d4", //#00ABF7",
        primaryFaded: "rgba(0, 120, 212, 0.2)",//"#0090FF",
        secondary: "#f6f6f6",
        touchColor: "#0078d4",
        particlesColor: "#fff",

        toolbarBg: "rgba(0,0,0,0.02)",//-
        toolbarText: "#424242",//buttonText
        toolbarHoverText: "#0078d4",

        dialogBgColor: "#0078d4",
        dialogTextColor: "#fff",
        dialogBorder: "none",

        /*dialog toolbar*/
        dialogToolbarBg: "#008FFC",
        dialogToolbarText: "#fff",//buttonText
        dialogToolbarHoverText: "darkblue",

        headerText: "#0078d4",
        headerBg: "rgba(0, 120, 212, 0.2)",
        
        scrollBarTrackColor: "rgba(0, 0, 0,0.1)",
        scrollBarThumbColor: "rgba(0, 0, 0,0.15)",
        scrollBarThumbHoverColor: "rgba(0, 0, 0,0.3)",

        bodyBg: "#fff",
        bodyText: "#424242",
        bodyBgImage: "none",
        appBarBg: "#0078d4",
        appBarHomeBg: "#4E9FFF",//"#0078d4",
        appBarHomeBgImage: "none",//"#0078d4",
        appBarBgImage: "linear-gradient(to right, #4E9FFF, #0078d4)",
        appBarBorderBottom: "none",//1px solid rgba(0, 0, 0, 0.16)",// "0px 1px 1px rgb(0 0 0 / 16%)",
        appBarLinkColor: "#FFF",//"#151515",
        appBarLinkActiveColor: "#004275",//"#00023D",// "#FFFD55",//"springgreen",
        pageContentBg: "transparent",
        pageManagerBg: "rgba(0,0,0,0.02)",//-
        footerBgImage: "linear-gradient(to right, #4E9FFF, #0078D4, #4E9FFF)",
        inputLabelColor: "#000",


        black: "#000",
        white: "#FFF",
        red: "#F00",
        green: "#22B14C",
        blue: "#0E98FF",
        orange: "orange",
        pink: "pink",
        purple: "purple",
        yellow: "yellow",

        info: "#3E80ED",
        infoFaded: "#BDE5F8",
        success: "#5eC232",
        successFaded: "#DFF2BF",
        warning: "#FDCE3E",
        warningFaded: "#FEEFB8",
        error: "#d51923",
        errorFaded: "#FFDADA",
        errorBg: "rgba(255, 0, 0, 0.6)",

        headingsText: "#272727",
        subtleText: "#666666",
        disabledText: "#8f8f8f",
        
        baseBg: "#fafafa",
        baseText: "#424242",
        hoveredBg: "#ececec",
        hoveredText: "#424242",        
        selectedBg: "#0078d4",
        selectedText: "#ffffff",
        buttonText: "#424242",
        buttonBg: "#f5f5f5",
        linkText: "#0078d4",
        linkHoverText: "#1d9fbc",

        componentBg: "#fff",
        componentBgFaded: "rgba(0, 0, 0, 0.02)",//-
        componentBgFadedDouble: "rgba(0, 0, 0, 0.02)",
        componentText: "#424242",
        componentBorderColor: "rgba(0, 0, 0, 0.1)",//mine
        componentBorderColorDouble: "rgba(0, 0, 0, 0.12)",//mine
        separatorColor: "rgba(0, 0, 0, 0.1)",//mine

        toggleTrackBgColor: "transparent",
        toggleSelectedBgColor: "#0078d4",
        toggleSelectedColor: "#fff",
        toggleUnSelectedColor: "#424242",

        //additional
        pagePadding: "0px",//26px 26px",
        pagePaddingRight: 0,
        paneSeparatorBg: "#fff",
        paneSeparatorWidth: "6px",//"26px"
        pageIntroBg: "#fff",
        pageHelpVisible: true,
        pageHelpBg: "#fff",
        managerBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageFormBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageHelpBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageBorderRadius: "0px",//"6px"
        
        // $series-a: #23bde0,
        // $series-b: #ffd246,
        // $series-c: #78d237;
        // $series-d: #28b4c8;
        // $series-e: #2d73f5;
        // $series-f: #aa46be;

        colorVariant1: "#0078d4",
        colorVariant2: "#0078d4",//"#5DC770",
        colorVariant3: "#0078d4",//"rgb(0,0,0)",

        gridHeaderBg: "rgba(0,0,0,0.02)", //-  
        gridHeaderColor: "#000",// "#FFF",//rgb(0,0,0)",
        gridPagerBg: "rgba(0,0,0,0.02)",//-
        gridPageNumberColor: "#000",
        gridPageSelectedNumberColor: "#0078d4",
        gridBorder: "1px solid rgba(0,0,0,0.1)",
        gridSelectedRow:"rgb(0,0,0,0.1)",
        gridSubscribedRow:"rgb(0,120,255,0.1)",

        reportViewTileBg: "#fff",
        burgerColor: "#fff",
        sideBarMiniBgColor: "#F7F7F7"
    },

    2: {
        id:2,
        name: "Main",
        darkTheme: false,
        colorTitle: "orange",
        borderRadius: 2,

        primary: "#000", //#00ABF7",
        primaryFaded: "#000",//"#0090FF",
        secondary: "#f6f6f6",
        touchColor: "#ff9600",
        particlesColor: "#fff",

        toolbarBg: "#FFF",//"rgba(0,0,0,0.02)",//-
        toolbarText: "#000",//buttonText
        toolbarHoverText: "#ff9600",

        dialogBgColor: "#0078d4",
        dialogTextColor: "#fff",
        dialogBorder: "none",

        /*dialog toolbar*/
        dialogToolbarBg: "#000",
        dialogToolbarText: "#fff",//buttonText
        dialogToolbarHoverText: "#ff9600",

        headerText: "#000",
        headerBg: "rgba(0, 120, 212, 0.2)",
        
        scrollBarTrackColor: "rgba(0, 0, 0,0.1)",
        scrollBarThumbColor: "rgba(0, 0, 0,0.15)",
        scrollBarThumbHoverColor: "rgba(0, 0, 0,0.3)",

        bodyBg: "#fff",
        bodyText: "#424242",
        bodyBgImage: "none",
        appBarBg: "#000",
        appBarHomeBg: "#000",//"#0078d4",
        appBarHomeBgImage: "none",//"#0078d4",
        appBarBgImage: "linear-gradient(to right, black, black)",
        appBarBorderBottom: "none",//1px solid rgba(0, 0, 0, 0.16)",// "0px 1px 1px rgb(0 0 0 / 16%)",
        appBarLinkColor: "#FFF",//"#151515",
        appBarLinkActiveColor: "#ff9600",//"#00023D",// "#FFFD55",//"springgreen",
        pageContentBg: "transparent",
        pageManagerBg: "rgba(0,0,0,0.02)",//-
        footerBgImage: "linear-gradient(to right, #4E9FFF, #0078D4, #4E9FFF)",
        inputLabelColor: "#000",


        black: "#000",
        white: "#FFF",
        red: "#F00",
        green: "#22B14C",
        blue: "#0E98FF",
        orange: "orange",
        pink: "pink",
        purple: "purple",
        yellow: "yellow",

        info: "#3E80ED",
        infoFaded: "#BDE5F8",
        success: "#5eC232",
        successFaded: "#DFF2BF",
        warning: "#FDCE3E",
        warningFaded: "#FEEFB8",
        error: "#d51923",
        errorFaded: "#FFDADA",
        errorBg: "rgba(255, 0, 0, 0.6)",

        headingsText: "#272727",
        subtleText: "#666666",
        disabledText: "#8f8f8f",
        
        baseBg: "#fafafa",
        baseText: "#424242",
        hoveredBg: "#ececec",
        hoveredText: "#424242",        
        selectedBg: "#0078d4",
        selectedText: "#ffffff",
        buttonText: "#424242",
        buttonBg: "#f5f5f5",
        linkText: "#000",
        linkHoverText: "#1d9fbc",

        componentBg: "#fff",
        componentBgFaded: "rgba(0, 0, 0, 0.02)",//-
        componentBgFadedDouble: "rgba(0, 0, 0, 0.02)",
        componentText: "#424242",
        componentBorderColor: "rgba(0, 0, 0, 0.1)",//mine
        componentBorderColorDouble: "rgba(0, 0, 0, 0.12)",//mine
        separatorColor: "rgba(0, 0, 0, 0.1)",//mine

        toggleTrackBgColor: "transparent",
        toggleSelectedBgColor: "#ff9600",
        toggleSelectedColor: "#000",
        toggleUnSelectedColor: "#000",

        //additional
        pagePadding: "0px",//26px 26px",
        pagePaddingRight: 0,
        paneSeparatorBg: "#fff",
        paneSeparatorWidth: "6px",//"26px"
        pageIntroBg: "#fff",
        pageHelpVisible: true,
        pageHelpBg: "#fff",
        managerBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageFormBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageHelpBorder: "1px solid rgba(0, 0, 0, 0.1)",
        pageBorderRadius: "0px",//"6px"
        
        // $series-a: #23bde0,
        // $series-b: #ffd246,
        // $series-c: #78d237;
        // $series-d: #28b4c8;
        // $series-e: #2d73f5;
        // $series-f: #aa46be;

        colorVariant1: "#0078d4",
        colorVariant2: "#0078d4",//"#5DC770",
        colorVariant3: "#0078d4",//"rgb(0,0,0)",

        gridHeaderBg: "rgba(0,0,0,0.02)", //-  
        gridHeaderColor: "#000",// "#FFF",//rgb(0,0,0)",
        gridPagerBg: "rgba(0,0,0,0.02)",//-
        gridPageNumberColor: "#000",
        gridPageSelectedNumberColor: "#ff9600",
        gridBorder: "1px solid rgba(0,0,0,0.1)",
        gridSelectedRow:"rgb(0,0,0,0.1)",
        gridSubscribedRow:"rgb(255,0,0,0.1)",

        reportViewTileBg: "#fff",
        burgerColor: "#fff",
        sideBarMiniBgColor: "#F7F7F7"
    },

   
    22:{
        id: 22,
        name:"Dark Blue - Red",
        darkTheme: true,
        colorTitle: "red",
        borderRadius: 2,

        primary: "rgb(56,97,136)",
        primaryFaded: "rgb(56,97,136)",
        secondary: "#f6f6f6",
        touchColor: "#f00",
        particlesColor: "#f00",

        toolbarBg: "transparent",
        toolbarText: "rgb(56,97,136)",
        toolbarHoverText: "#f00",

        dialogBgColor: "#002240",
        dialogTextColor: "#fff",
        dialogBorder: "2px solid #3C678D",

        /*dialog toolbar*/
        dialogToolbarBg: "#00172B",/*"#002240",*/
        dialogToolbarText: "#fff",
        dialogToolbarHoverText: "#f00",

        headerText: "#fff",
        headerBg: "#002D54",

        scrollBarTrackColor: "#002240",
        scrollBarThumbColor: "rgb(56, 97, 136)",
        scrollBarThumbHoverColor: "rgb(56, 97, 136)",

        bodyBg: "transparent",
        bodyBgImage: "linear-gradient(to right, #002D54, #002240)",
        bodyText: "#ffffff",
        appBarBg: "#002D54",//"#002240",//"#0078d4",
        appBarHomeBg:  "rgb(0,34,64)",//"#002240",//"#0078d4",
        appBarHomeBgImage: "none",//"#0078d4",
        appBarBgImage: "linear-gradient(to right, #002D54, #002240)",
        appBarBorderBottom: "2px solid #3C678D",//"2px solid #424242","#3C678D",//"2px solid #424242",
        appBarLinkColor: "#fff", /*"#3C678D",*/
        appBarLinkActiveColor: "#f00",
        pageContentBg: "#002240",
        pageManagerBg: "rgb(56, 97, 136)",
        footerBgImage: "linear-gradient(to right, rgb(0, 34, 64), #002240, rgb(0, 34, 64))",
        inputLabelColor: "#6495ED",

        black: "#000",
        white: "#FFF",
        red: "#F00",
        green: "#22B14C",
        blue: "#0E98FF",
        orange: "orange",
        pink: "pink",
        purple: "purple",
        yellow: "yellow",

        info: "#3e80ed",
        infoFaded: "#BDE5F8",
        success: "#5ec232",
        successFaded: "#DFF2BF",
        warning: "#fdce3e",
        warningFaded: "#DFF2BF",
        error: "#d51923",
        errorFaded: "#FFDADA",
        errorBg: "rgba(255, 0, 0, 0.6)",

        headingsText: "#ffffff",
        subtleText: "#e0e0e0",
        disabledText: "#d0d0d0",

        baseBg: "#002240",
        baseText: "#ffffff",
        hoveredBg: "#202020",//example when hovering a menuitem
        hoveredText: "#ffffff",
        selectedBg: "rgb(56,97,136)",
        selectedText: "#FFFFFF",
        buttonText: "#fff",
        buttonBg: "#3C678D",
        linkText: "rgb(56,97,136)",//primary color - menu item text color
        linkHoverText: "#38c138",//modified primary color - menu item text hover color
  
        componentBg: "#002240",//card bg color
        componentBgFaded: "#002D54",
        componentText: "#fff",//card color
        componentBorderColor: "#3C678D",// "rgba(255, 255, 255, 0.08)",//mine - that of kindo is same as light=rgba(0, 0, 0, 0.1) which is invisible on black such as in card
        componentBorderColorDouble: "#3C678D",
        separatorColor: "#3C678D",//"#3C678D",//rgba(255, 255, 255, 0.08)"

        toggleTrackBgColor: "transparent",
        toggleSelectedBgColor: "rgb(56, 97, 136)",
        toggleSelectedColor: "#fff",
        toggleUnSelectedColor: "#fff",

         //additional
         pagePadding: "36px 36px",
         pagePaddingRight: "36px",
         paneSeparatorBg: "transparent",
         paneSeparatorWidth: "36px",
         pageIntroBg: "#002D54",
         pageHelpVisible: true,
         pageHelpBg: "#002D54",
         managerBorder: "2px solid #3C678D",
         pageFormBorder: "2px solid #3C678D",
         pageHelpBorder: "3px solid #3C678D",
         pageBorderRadius: "8px", 
         reportViewTileBg: "#00182E",

         colorVariant1: "#f00",
         colorVariant2: "#f00",
         colorVariant3: "#f00",

         gridHeaderBg: "#00182E",         
         gridHeaderColor: "#fff",
         gridPagerBg: "#00182E",
         gridPageNumberColor: "#fff",
         gridPageSelectedNumberColor: "red",//"#f00",
         gridBorder: "1px solid rgb(56, 97, 136)",
         burgerColor: "#f00",
         sideBarMiniBgColor: "#002240",
         gridSelectedRow:"rgb(0,0,0,0.1)",
         gridSubscribedRow:"rgb(255,0,0,0.1)",

    },
};